import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as Constants from '../configs/constants';

import axios from 'axios';

export const getQuotes = createAsyncThunk(
  'quotes/list',
  async (data, thunkAPI) => {
    try {
      const userData = data;
      return await axios.post(Constants.API_URL + 'Quotes/getQuotesList', userData, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwt_access_token')
        }
      })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          } else {
            return thunkAPI.rejectWithValue(response);
          }
        })
    } catch (e) {
      console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const submitQuote = createAsyncThunk(
  'quote/submit',
  async (data, thunkAPI) => {
    try {
      const userData = data;
      return await axios.post(Constants.API_URL + 'Quotes/submitQuote', userData, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwt_access_token'),
          "Content-Type": "multipart/form-data",
        }
      })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          } else {
            return thunkAPI.rejectWithValue(response);
          }
        })
    } catch (e) {
      console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const declineQuote = createAsyncThunk(
  'quote/decline',
  async (data, thunkAPI) => {
    try {
      const userData = data;
      return await axios.post(Constants.API_URL + 'Quotes/declineQuote', userData, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwt_access_token')
        }
      })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          } else {
            return thunkAPI.rejectWithValue(response);
          }
        })
    } catch (e) {
      console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const manualQuoteSubmit = createAsyncThunk(
  'quote/manual',
  async (data, thunkAPI) => {
    try {
      const userData = data;
      return await axios.post(Constants.API_URL + 'Quotes/submitManualQuote', userData, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwt_access_token')
        }
      })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          } else {
            return thunkAPI.rejectWithValue(response);
          }
        })
    } catch (e) {
      console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const removeQuoteFile = createAsyncThunk(
  'quote/removeFile',
  async (data, thunkAPI) => {
    try {
      const userData = data;
      return await axios.post(Constants.API_URL + 'Quotes/removeQuoteFile', userData, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwt_access_token')
        }
      })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          } else {
            return thunkAPI.rejectWithValue(response);
          }
        })
    } catch (e) {
      console.log('Error', e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getQuestionsByQuote = createAsyncThunk(
  "quote/listOfQuestions",
  async (data, thunkAPI) => {
    try {
      const userData = data;
      return await axios
        .post(Constants.API_URL + "Questions/getQuestionsByQuote", userData, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("jwt_access_token"),
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          } else {
            return thunkAPI.rejectWithValue(response);
          }
        });
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const saveQuoteQuestions = createAsyncThunk(
  "quote/saveQuoteQuestions",
  async (data, thunkAPI) => {
    try {
      const userData = data;
      return await axios
        .post(Constants.API_URL + "Questions/saveQuoteQuestions", userData, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("jwt_access_token"),
            "Content-Type" : "multipart/form-data",
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            return response.data;
          } else {
            return thunkAPI.rejectWithValue(response);
          }
        });
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const quotesSlice = createSlice({
  name: 'quotes',
  initialState: {
    isQuotesFetching: false,
    isQuotesSuccess: false,
    isQuotesError: false,
    quotesErrorMessage: '',
    quotesList: [],
    quoteQuestions: [],
    isSubmitQuoteFetching: false,
    isSubmitQuoteSuccess: false,
    isSubmitQuoteError: false,
    submitQuoteErrorMessage: '',
    isDeclineQuoteFetching: false,
    isDeclineQuoteSuccess: false,
    isDeclineQuoteError: false,
    declineQuoteErrorMessage: '',

    isRemoveQuoteFileFetching: false,
    isRemoveQuoteFileSuccess: false,
    isRemoveQuoteFileError: false,
    removeQuoteFileErrorMessage: '',

    isManualQuoteSubmitFetching: false,
    isManualQuoteSubmitSuccess: false,
    isManualQuoteSubmitError: false,
    manualQuoteSubmitErrorMessage: '',

    isGetQuestionsByQuoteFetching: false,
    isGetQuestionsByQuoteSuccess: false,
    isGetQuestionsByQuoteError: false,
    getQuestionsByQuoteErrorMessage: '',

    isSaveQuoteQuestionsFetching: false,
    isSaveQuoteQuestionsSuccess: false,
    isSaveQuoteQuestionsError: false,
    saveQuoteQuestionsErrorMessage: '',
  },
  reducers: {
    clearQuotesState: (state) => {
      state.isQuotesError = false;
      state.isQuotesSuccess = false;
      state.isQuotesFetching = false;
      state.quotesList = [];
      return state;
    },
    clearSubmitQuoteState: (state) => {
      state.isSubmitQuoteError = false;
      state.isSubmitQuoteFetching = false;
      state.isSubmitQuoteSuccess = false;
      state.submitQuoteErrorMessage = "";
      return state;
    },
    clearRemoveQuoteFileState: (state) => {
      state.isRemoveQuoteFileError = false;
      state.isRemoveQuoteFileFetching = false;
      state.isRemoveQuoteFileSuccess = false;
      state.removeQuoteFileErrorMessage = "";
      return state;
    },
    clearManualQuoteSubmitState: (state) => {
      state.isManualQuoteSubmitError = false;
      state.isManualQuoteSubmitFetching = false;
      state.isManualQuoteSubmitSuccess = false;
      state.manualQuoteSubmitErrorMessage = "";
      return state;
    },
    clearGetQuoteQuestionsState: (state) => {
      state.isGetQuestionsByQuoteError = false;
      state.isGetQuestionsByQuoteFetching = false;
      state.isGetQuestionsByQuoteSuccess = false;
      state.getQuestionsByQuoteErrorMessage = "";
      state.quoteQuestions = [];
      return state;
    },
    clearSaveQuoteQuestionsState: (state) => {
      state.isSaveQuoteQuestionsError = false;
      state.isSaveQuoteQuestionsFetching = false;
      state.isSaveQuoteQuestionsSuccess = false;
      state.saveQuoteQuestionsErrorMessage = "";
      return state;
    }
  },
  extraReducers: {
    [getQuotes.fulfilled]: (state, { payload }) => {
      state.isQuotesFetching = false;
      state.quotesList = payload;
      state.isQuotesSuccess = true;
      return state;
    },
    [getQuotes.rejected]: (state, { payload }) => {
      state.isQuotesFetching = false;
      state.isQuotesError = true;
      state.quotesErrorMessage = payload && payload.error_description ? payload.error_description : "Invalid Credentials. Please try again!";
    },
    [getQuotes.pending]: (state) => {
      state.isQuotesFetching = true;
    },
    [submitQuote.fulfilled]: (state, { payload }) => {
      state.isSubmitQuoteFetching = false;
      state.isSubmitQuoteSuccess = true;
      return state;
    },
    [submitQuote.rejected]: (state, { payload }) => {
      state.isSubmitQuoteFetching = false;
      state.isSubmitQuoteError = true;
      state.submitQuoteErrorMessage = payload && payload.error_description ? payload.error_description : "Invalid Credentials. Please try again!";
    },
    [submitQuote.pending]: (state) => {
      state.isSubmitQuoteFetching = true;
    },
    [removeQuoteFile.fulfilled]: (state, { payload }) => {
      state.isRemoveQuoteFileFetching = false;
      state.isRemoveQuoteFileSuccess = true;
      return state;
    },
    [removeQuoteFile.rejected]: (state, { payload }) => {
      state.isRemoveQuoteFileFetching = false;
      state.isRemoveQuoteFileError = true;
      state.removeQuoteFileErrorMessage = payload && payload.error_description ? payload.error_description : "Invalid Credentials. Please try again!";
    },
    [removeQuoteFile.pending]: (state) => {
      state.isRemoveQuoteFileFetching = true;
    },
    [declineQuote.fulfilled]: (state, { payload }) => {
      state.isDeclineQuoteFetching = false;
      state.isDeclineQuoteSuccess = true;
      return state;
    },
    [declineQuote.rejected]: (state, { payload }) => {
      state.isDeclineQuoteFetching = false;
      state.isDeclineQuoteError = true;
      state.declineQuoteErrorMessage = payload && payload.error_description ? payload.error_description : "Invalid Credentials. Please try again!";
    },
    [declineQuote.pending]: (state) => {
      state.isDeclineQuoteFetching = true;
    },
    [manualQuoteSubmit.fulfilled]: (state, { payload }) => {
      state.isManualQuoteSubmitFetching = false;
      state.isManualQuoteSubmitSuccess = true;
      return state;
    },
    [manualQuoteSubmit.rejected]: (state, { payload }) => {
      state.isManualQuoteSubmitFetching = false;
      state.isManualQuoteSubmitError = true;
      state.manualQuoteSubmitErrorMessage = payload && payload.error_description ? payload.error_description : "Invalid Credentials. Please try again!";
    },
    [manualQuoteSubmit.pending]: (state) => {
      state.isManualQuoteSubmitFetching = true;
    },
    [getQuestionsByQuote.fulfilled]: (state, { payload }) => {
      state.isGetQuestionsByQuoteFetching = false;
      state.isGetQuestionsByQuoteSuccess = true;
      state.quoteQuestions = payload && payload.data || [];
      return state;
    },
    [getQuestionsByQuote.rejected]: (state, { payload }) => {
      state.isGetQuestionsByQuoteFetching = false;
      state.isGetQuestionsByQuoteError = true;
      state.getQuestionsByQuoteErrorMessage = payload && payload.error_description ? payload.error_description : "Invalid Credentials. Please try again!";
    },
    [getQuestionsByQuote.pending]: (state) => {
      state.isGetQuestionsByQuoteFetching = true;
    },
    [saveQuoteQuestions.fulfilled]: (state, { payload }) => {
      state.isSaveQuoteQuestionsFetching = false;
      state.isSaveQuoteQuestionsSuccess = true;
      return state;
    },
    [saveQuoteQuestions.rejected]: (state, { payload }) => {
      state.isSaveQuoteQuestionsFetching = false;
      state.isSaveQuoteQuestionsSuccess = true;
      state.saveQuoteQuestionsErrorMessage = payload && payload.error_description ? payload.error_description : "Invalid Credentials. Please try again!";
    },
    [saveQuoteQuestions.pending]: (state) => {
      state.isSaveQuoteQuestionsFetching = true;
    }
  },
});

export const { clearQuotesState, clearSubmitQuoteState, clearRemoveQuoteFileState, clearManualQuoteSubmitState, clearGetQuoteQuestionsState, clearSaveQuoteQuestionsState } = quotesSlice.actions;

export const quotesSelector = (state) => state.quotes;

export default quotesSlice.reducer;
